// Places autocomplete lives in src/api/PlacesAPI.js.

// ---------------------------------------------------------------------------
// Date-change → notify-attendees helpers.
// When an event created more than a week ago has its date moved, attendees have
// likely already RSVP'd around the old date, so we offer to post a heads-up to
// the event chat (which the existing onChatMessage broadcast fans out to SMS +
// push). These helpers normalize the various date shapes (Firestore Timestamp,
// Date, ISO string) and pre-draft the message.
// ---------------------------------------------------------------------------
export const NOTIFY_DATE_CHANGE_AGE_MS = 7 * 24 * 60 * 60 * 1000; // "more than 1 week"

export const toDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (typeof value.toDate === "function") {
    const d = value.toDate();
    return isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const toMillisSafe = (value) => {
  if (value && typeof value.toMillis === "function") return value.toMillis();
  const d = toDateSafe(value);
  return d ? d.getTime() : null;
};

export const formatEventDate = (date) =>
  date.toLocaleString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export const buildDateChangeMessage = (name, date) => {
  const title = name ? `"${name}"` : "our event";
  return `Heads up — the date for ${title} has changed. 📅\n\nWe're now meeting on ${formatEventDate(
    date
  )}. We hope you can still make it! Reply here if you have any questions.`;
};
